module.exports = __webpack_public_path__ + "img/plus.svg";